import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Capacitor } from '@capacitor/core';
import './AndroidAppBanner.css';

const STORAGE_KEY = 'android_app_banner_dismissed';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.jogolinga.com';

function isAndroidBrowser(): boolean {
  return /Android/i.test(navigator.userAgent);
}

const AndroidAppBanner: React.FC = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (
      !Capacitor.isNativePlatform() &&
      isAndroidBrowser() &&
      !localStorage.getItem(STORAGE_KEY)
    ) {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  const openApp = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    window.open(PLAY_STORE_URL, '_blank', 'noopener,noreferrer');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="aab" role="dialog" aria-label={t('androidAppBanner.ariaLabel') as string}>
      <div className="aab__inner">
        <img src="/assets/web-app-manifest-192x192.png" alt="" className="aab__icon" />
        <p className="aab__text">{t('androidAppBanner.text')}</p>
        <div className="aab__actions">
          <button className="aab__btn aab__btn--open" onClick={openApp}>
            {t('androidAppBanner.open')}
          </button>
          <button
            className="aab__btn aab__btn--dismiss"
            onClick={dismiss}
            aria-label={t('androidAppBanner.dismiss') as string}
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default AndroidAppBanner;
